import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UnlockRewardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UnlockRewardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const unlockReward = (request: UnlockRewardRequest, options?: CashRequestOptions) =>
  post<UnlockRewardRequest, UnlockRewardResponse>('/2.0/cash/unlock-reward', request, {
    ...options,
    rejectOnError: true,
  })
